import type { V2 } from '../core/math';

/**
 * What a crew knows about the suspect (offline police, docs/POLICE.md §12). Pure, so the fairness
 * rule is unit-tested: a crew steers by what it has SEEN, never by where the player really is.
 */

/** Seconds a crew keeps extrapolating its last sighting; after that it holds the last guess. */
export const DEAD_RECKON_MAX = 1.5;

export interface Sighting {
  /** Where the suspect was when last seen, how they were moving, which way they faced. */
  pos: V2;
  vel: V2;
  heading: number;
  /** Sim time of that sighting. */
  at: number;
}

export interface SuspectEstimate {
  pos: V2;
  vel: V2;
  heading: number;
  speed: number;
}

/** Last seen position + last seen velocity × time since (capped at DEAD_RECKON_MAX). */
export function deadReckon(s: Sighting, now: number): SuspectEstimate {
  const age = Math.min(DEAD_RECKON_MAX, Math.max(0, now - s.at));
  return {
    pos: { x: s.pos.x + s.vel.x * age, z: s.pos.z + s.vel.z * age },
    vel: { x: s.vel.x, z: s.vel.z },
    heading: s.heading,
    speed: Math.hypot(s.vel.x, s.vel.z),
  };
}
